import { render } from "./TaskGraph.vue?vue&type=template&id=815ec2ea&scoped=true"
import script from "./TaskGraph.vue?vue&type=script&lang=js"
export * from "./TaskGraph.vue?vue&type=script&lang=js"

import "./TaskGraph.vue?vue&type=style&index=0&id=815ec2ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-815ec2ea"]])

export default __exports__